<div class="popup">
	<div class="popup-header">
		<div class="popup-title">{{(this.shiftId ? 'SCHEDULE.EDIT' : 'SCHEDULE.ADD') | translate}}</div>
		<div class="date-and-department-name-holder">
			<div class="date-selected">{{(shiftId ? shift?.visible_date : date) | smLocalDate:'mediumDate'}}</div>
			<div *ngIf="department" class="department-name">{{department.department_name}}</div>
			<div class="qo-margin-left20">
				<qo-input-dropdown
					*ngIf="canCreateSickMessage"
					[icon]="EQORebrandIcon.more_dark"
					[invertedScheme]="true"
					[scheme]="EQORebrandColor.SECONDARY"
					[compact]="true"
					[border]="false"
					[actions]="shiftActions"
					[size]="'small'"
				></qo-input-dropdown>
			</div>
		</div>
	</div>
	<form
		[formGroup]="form"
		class="popup-body"
	>
		<div class="inputs">
			<div class="qo-form-row">
				<qo-form-block>
					<qo-time-input
						[label]="'GLOBAL.TIME' | translate"
						[fromPlaceholder]="'GLOBAL.FROM' | translate"
						[toPlaceholder]="'GLOBAL.TO' | translate"
						controlName="time"
						(keyup.enter)="save()"
					></qo-time-input>
				</qo-form-block>
				<qo-form-block
					[label]="'GLOBAL.PAUSE' | translate"
				>
					<qo-input-text
						[placeholder]="'GLOBAL.PAUSE' | translate"
						formControlName="pause"
						type="number"
						(keyup.enter)="save()"
					></qo-input-text>
				</qo-form-block>
			</div>
			<div class="qo-form-row">
				<qo-form-block [label]="'GLOBAL.USER' | translate">
					<qo-input-select
						[options]="userOptions"
						formControlName="selectedUser"
					></qo-input-select>
				</qo-form-block>
				<qo-form-block [label]="'GLOBAL.GROUP' | translate">
					<qo-input-select
						[options]="groupOptions"
						formControlName="selectedGroup"
					></qo-input-select>
				</qo-form-block>
			</div>
			<div class="qo-form-row">
				<qo-input-checkbox
					*ngIf="this.shiftId && this.selectedUserControl.value?.data.id !== 1"
					[label]="'SCHEDULE.APPROVED_FOR_SALARY' | translate"
					formControlName="approved"
				></qo-input-checkbox>
			</div>
		</div>
		<div
			*ngIf="sickDay"
			class="qo-flex-row-top-left sick"
		>
			<div class="qo-flex-row-space-between sick-day">
				<div class="qo-flex-row-top-left align-center">
					<qo-icon
						[icon]="EQORebrandIcon.sick_dark"
						[invertedScheme]="true"
						[scheme]="EQORebrandColor.NO"
						[color]="EQORebrandColor.NO"
						[size]="'sm'"
					></qo-icon>
					<span class="qo-margin-left10 qo-no">
						{{'SICK_DAY.SICK' | translate}}
					</span>
				</div>
				<div class="qo-flex-col-top-right">
					<button
						class="qo-button-small qo-secondary-invert"
						(click)="viewSickDayAnswers()"
					>
						{{(user$ | async).permission_level === 2 ? ('SICK_DAY.VIEW_ANSWERS' | translate) : 'SICK_DAY.ANSWER' | translate}}
					</button>
				</div>
			</div>
		</div>
		<div class="tabs">
			<div class="qo-margin-bottom24">
				<qo-tabs
					class="qo-max-width"
					[tabs]="tabs"
					(tabChange)="switchTap($event)"
				></qo-tabs>
			</div>
			<div *ngIf="currentTab.index === 0">
				<label class="qo-label">
			    <textarea
						class="qo-input textarea"
						formControlName="note"
						[readonly]="!(user$ | async).isAdmin()"
						(keyup.enter)="save()"
					></textarea>
				</label>
			</div>
			<div *ngIf="currentTab.index === 1">
				<ng-container *ngIf="punchNotApprovedReasons.length > 0">
					<ul>
						<li
							*ngFor="let reason of punchNotApprovedReasons">{{ ('GLOBAL.PUNCH_NOT_APPROVED_REASONS.' + reason) | translate }}</li>
					</ul>
				</ng-container>
				<label class="qo-label">
					{{'SCHEDULE.NOTE_FROM_EMPLOYEE' | translate}}
					<textarea class="qo-input textarea" formControlName="punch_note" readonly></textarea>
				</label>
			</div>
			<div *ngIf="currentTab.index === 2" class="logs">
				<qo-loader *ngIf="(isLoadingActivities$ | async) || (isLoadingRelationActivity$ | async)"></qo-loader>
				<div class="log-connected-line" *ngIf="(activities$ | async).length > 1"></div>
				<ng-container *ngFor="let activity of (activities$ | async)">
					<div class="log qo-flex-row-top-left">
						<qo-profile-image
							[letter]="(activity.causer) ? activity.causer.getInitials() : ''"
							[imageUrl]="activity.causer.profile_picture ? activity.causer.profile_picture.download_url : undefined"
							[backgroundColor]="EQORebrandColor.WHITE"
							[size]="40"
							[fontSize]="14"
						></qo-profile-image>

						<div class="log-text qo-flex-col-center-left">
							<div class="log-text">
								<div class="causer-and-action">
									<div class="marked-words">{{(activity.causer) ? activity.causer.getShortName() : 'The system'}}</div>
									<div>&nbsp;{{activity.getTitle()}}</div>
								</div>
								<div class="properties" *ngIf="activity.lines.length > 0">
									<div *ngFor="let lines of activity.lines">
										<div class="bullet"></div>
										<div class="property-changed">
											<div *ngFor="let line of lines" [class.marked-words]="line.marked">{{line.text}}</div>
										</div>
									</div>
								</div>
							</div>
							<div class="log-date-text">{{activity.created_at.localDate | smLocalDate:'short'}}</div>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
	</form>

	<div class="popup-footer">
		<button class="qo-button-standard qo-grey" (click)="close()">{{ 'GLOBAL.CLOSE' | translate }}</button>
		<ng-container *ngIf="!(user$ | async).isAdmin()">
			<button
				*ngIf="workerShiftType == 1"
				class="qo-button-standard qo-primary"
				(click)="addToStock()"
				[class.qo-button-loader]="(isShiftUpdatingLoading$ | async)"
				[disabled]="shift.start.localDate.isSameOrBefore(momentNow) || (isShiftUpdatingLoading$ | async)">{{ 'SCHEDULE.ADD_TO_SHIFT_STOCK' | translate }}
			</button>
			<button
				*ngIf="workerShiftType == 2"
				class="qo-button-standard qo-primary"
				(click)="removeFromStock()"
				[class.qo-button-loader]="(isShiftUpdatingLoading$ | async)"
				[disabled]="(isShiftUpdatingLoading$ | async)"
			>{{ 'SCHEDULE.REMOVE_FROM_SHIFT_STOCK' | translate }}
			</button>
			<button
				*ngIf="workerShiftType == 3"
				class="qo-button-standard qo-primary"
				(click)="addBid()"
				[disabled]="shift.start.localDate.isSameOrBefore(momentNow)|| (isShiftUpdatingLoading$ | async)"
				[class.qo-button-loader]="(isShiftUpdatingLoading$ | async)"
			>
				{{ 'SCHEDULE.BID_ON_SHIFT' | translate }}
			</button>
			<button
				*ngIf="workerShiftType == 4"
				class="qo-button-standard qo-primary"
				(click)="removeBid()"
				[disabled]="(isShiftUpdatingLoading$ | async)"
				[class.qo-button-loader]="(isShiftUpdatingLoading$ | async)"
			>{{ 'SCHEDULE.REMOVE_BID_ON_SHIFT' | translate }}</button>
		</ng-container>
		<ng-container *ngIf="(user$ | async).isAdmin()">
			<button
				*ngIf="shiftId !== undefined"
				class="qo-button-standard qo-no-invert"
				(click)="delete()"
				[disabled]="(isShiftUpdatingLoading$ | async)"
			>
				{{ 'GLOBAL.DELETE' | translate }}
			</button>
			<button
				class="qo-button-standard qo-primary"
				(click)="save()"
				[disabled]="form.invalid || (isShiftUpdatingLoading$ | async)"
			>
				{{ (this.shiftId ? 'GLOBAL.SAVE' : 'GLOBAL.ADD') | translate }}
			</button>
		</ng-container>
	</div>
</div>
